import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useStateContext } from "../Contexts/ContextProvider";

const GuestLayout = () => {
  
  const { token } = useStateContext();

  if (token) {
    return <Navigate to="/dashboard" />;
  }
 
  return (
     <Outlet/>
  );
};

export default GuestLayout;